import React from "react";
import { Skeleton } from "antd";

interface StudentMetricCardProps {
  title: string;
  icon: string;
  count?: number;
  login?: number;
  notLogin?: number;
  isLoading: boolean;
  className?: string;
}

const StudentMetricCard: React.FC<StudentMetricCardProps> = ({
  title,
  icon,
  count,
  login,
  notLogin,
  isLoading,
  className = "",
}) => {
  return (
    <div className={`student-metric__card ${className}`}>
      <div className="student-metric__card-header">
        <div className="student-metric__card-icon__container">
          <img src={icon} />
        </div>
        <div className="student-metric__card-title__container">
          <p className="title">{title}</p>
          {isLoading ? (
            <Skeleton active paragraph={{ rows: 0 }} className="align-right mt-2" />
          ) : (
            <p className="count">{count}</p>
          )}
        </div>
      </div>
      <div className="student-metric__card-content">
        <div className="student-metric__card-content-count__container">
          <p className="title">Login</p>
          {isLoading ? <Skeleton active paragraph={{ rows: 0 }} /> : <p className="value">{login}</p>}
        </div>
        <div className="student-metric__card-content-count__container">
          <p className="title">Not Login</p>
          {isLoading ? <Skeleton active paragraph={{ rows: 0 }} /> : <p className="value">{notLogin}</p>}
        </div>
      </div>
    </div>
  );
};

export default StudentMetricCard;
